import { render, staticRenderFns } from "./user-confirm-email.component.vue?vue&type=template&id=2cc8a6c2&"
import script from "./user-confirm-email.component.ts?vue&type=script&lang=ts&"
export * from "./user-confirm-email.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-confirm-email.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
